/* @sravni/react-design-system version 0.2.65 */
var css = "._19kf9l0 {\n  width: 100%;\n}\n";
var modules_ff399ec7 = {"container":"_19kf9l0"};
import "../../../assets/components/ControlGroup/src/ControlGroup-ae928f91.css";

export default modules_ff399ec7;
export { css };
